import StudentWorkExperience from "./src/main";
/* istanbul ignore next */
StudentWorkExperience.install = function (Vue) {
  Vue.component(StudentWorkExperience.name, StudentWorkExperience);
};

export default StudentWorkExperience;
